var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{ref:"table",attrs:{"service":_vm.service,"entity":_vm.entity,"filters":_vm.filters,"columns":_vm.columns,"disable-permission-checks":true,"operations":"add,edit,delete"},scopedSlots:_vm._u([{key:"created_at",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.$formatDate(row.created_at, _vm.FRIENDLY_DATE_FORMAT)))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }